import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromTranslation from '../reducers/translation.reducer';

const selectTranslationState = createFeatureSelector<fromTranslation.State>(fromTranslation.translationFeatureKey);

export const selectDefaultFileTranslation = createSelector(
    selectTranslationState,
    (state: fromTranslation.State) => state.defaultFileTranslation
);

export const selectFileTranslation = createSelector(
    selectTranslationState,
    (state: fromTranslation.State) => state.fileTranslation
);
